import { cssVar } from '@chakra-ui/react';
const arrowBg = cssVar('popper-arrow-bg');
const tooltipStyles = (tokens) => ({
    baseStyle: {
        padding: '10px',
        border: tokens.BorderWidth01,
        borderColor: 'transparent',
        bgColor: tokens.CanvasDarkGrey,
        borderRadius: tokens.BorderRadius04,
        [arrowBg.variable]: tokens.CanvasDarkGrey,
    },
});
export default tooltipStyles;
